module.exports = __webpack_public_path__ + "img/pIndex-dialog-wx.47e69d26.png";